import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_6pxaaxfg: FaireBrandEntity = {
  token: "b_6pxaaxfg",
  type: "brand",
  name: "La Familia Green",
  avatarUrl:
    "https://cdn.faire.com/fastly/5e95a0d10f2e4f37f403c1b0e3afeb682b29cf483e69a9100a971a4192b0e47f.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/e10e9c93d17a4827f7d95f1113b02932bb4fec5b6f12724efb4376837be361a4.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/5e95a0d10f2e4f37f403c1b0e3afeb682b29cf483e69a9100a971a4192b0e47f.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/e10e9c93d17a4827f7d95f1113b02932bb4fec5b6f12724efb4376837be361a4.jpeg",
  location: "Chicago, IL, USA",
  minimumOrderDollars: 50,
  rating: 5,
  reviewCount: 250,
  isInsider: true,
  description:
    "Greeting cards and paper products hand illustrated by Mollie Green - I grew up among the dusty tumbleweeds of Lubbock, Texas. And after moving to the Midwest in high school, I completed a BFA in painting and printmaking at the School of the Art Institute of Chicago. Graduation forced the lesson of how to live and work as an artist—that meant retail by day, artist by night. Attempting to integrate retail skills with artistic training and a love of multiples led to the birth of La Familia Green in 2005. I am a fourth generation small business owner. I love the immediacy and intimacy of cards. You buy a card, write a note and send it out into the world. I never know how many people will experience - hold, use, enjoy - my work. I also love that I can easily and quickly express my interests through this medium. As new card ideas come to me, I jot them down in notes app. And all illustrations are done by hand, by me--no AI ever!\n\nRunning and rescue pets are my passions. I donate 10% a month back to local charities. I am also proud to be vegan - so keep in mind that all of those corndogs and nachos in my work are plant based! ;)",
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:56:02.214Z",
    importedBy: "entity-db-cli",
  },
};
